export async function loadFarcasterSdk() {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const mod = await import('@farcaster/miniapp-sdk');
    return mod.sdk ?? null;
  } catch {
    return null;
  }
}

